import React, { Suspense, lazy } from "react";
import { createFileRoute, useParams } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { useStaffLL97SubmissionQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — Staff LL97 submission page (heavy wizard surface)
// lazy-loaded.
const LL97Page = lazy(() => import("@/pages/Staff/LL97/Submission/Page"));

// Prominent "CY{year}" pill. Deliberately uses text + a shape that doesn't
// rely on color alone — staff/RDPs must never mistake which calendar year
// they're certifying; getting this wrong has legal liability implications.
const CalendarYearPill: React.FC<{ year: number | undefined }> = ({ year }) =>
  typeof year === "number" ? (
    <span
      aria-label={`Calendar year ${year}`}
      className="inline-flex items-center rounded-md border border-blue-600 bg-blue-50 text-blue-800 px-3 py-1 text-sm font-semibold"
    >
      {`CY${year}`}
    </span>
  ) : null;

const LL97Route = () => {
  const { submissionId } = useParams({ from: "/staff/ll97/$submissionId" });
  const { data } = useStaffLL97SubmissionQuery(submissionId);
  const year: number | undefined =
    data?.submission?.calendarYear ?? data?.calendarYear;

  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader header="LL97" />
      <div className="flex items-center gap-3 px-10 pt-4">
        <CalendarYearPill year={year} />
      </div>
      <Suspense fallback={null}>
        <LL97Page />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute("/staff/ll97/$submissionId")({
  component: LL97Route,
});
